module.exports = __webpack_public_path__ + "assets/GTAmerica-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Regular.eot
// module id = 1014
// module chunks = 19